import { AxiosResponse } from "../axios";

export class ApiPagination {
  totalCount?: number;
  pagesCount?: number;
  currentPageNumber?: number;
  currentPageSize?: number;
  hasNext?: boolean;
  hasPrev?: boolean;
  constructor(response: AxiosResponse) {
    const meta = response.data.meta;
    this.totalCount = meta.total_count;
    this.pagesCount = meta.pages_count;
    this.currentPageNumber = meta.current_page_number;
    this.currentPageSize = meta.current_page_size;
    this.hasNext = meta.has_next;
    this.hasPrev = meta.has_prev;
  }
}
